export const FOOTER_LOGO_TYPES = {
  black: 'black',
  dark: 'dark',
  white: 'white',
  darkMode: 'dark-mode',
}
